import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.regexp.split.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { urlBuilder } from '~/mixins/BuildUrl';
import registerStoreModule from '~/helpers/store-helper';
import { extractProductReference } from '~/helpers/extract-helper';
import product from '~/store/modules/product';
import { WIBILONG_JS_URL, WIBILONG_CSS_URL } from '~/const/3rd';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
import ProductGlide from '~/components/functional/UI/ProductGlide.vue';
import SquareImage from '~/components/atoms/Product/SquareImage.vue';
import ProductLoading from '~/components/organisms/Product/ProductLoading.vue';
import MdmIcon from '~/components/atoms/Global/MdmIcon';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/geoloc.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/square-carousel.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/video-icon-play-mobile.svg';
import USE_MARKETPLACE from '~/const/marketplace';

var CommercialRibbon = () => import(
/* webpackChunkName: "commercial-ribbon" */
'~/components/atoms/Global/CommercialRibbon.vue');

var ThePriceSection = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/ThePriceSection.vue');

var TheVariantsSection = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/TheVariantsSection.vue');

var ZoomModal = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/molecules/Product/ZoomModal.vue');

var YoutubeModal = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/molecules/Product/Modal/YoutubeModal.vue');

var ThumbnailList = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/ThumbnailList.vue');

var TheEmailForm = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/molecules/Product/TheEmailForm.vue');

var TheCartSection = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/TheCartSection.vue');

var Reinsurance = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/Reinsurance.vue');

var ZoomableImage = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/molecules/Product/ZoomableImage.vue');

var Heart = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/atoms/Global/Heart.vue');

var ProductStock = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/atoms/Product/ProductStock.vue');

var CrossEarlyBirds = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/CrossEarlyBirds.vue');

var ShopTheLook = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/ShopTheLook.vue');

var ProductInformation = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/ProductInformation');

var ProductFlags = () => import(
/* webpackChunkName: "product-flags" */
'~/components/organisms/Product/ProductFlags.vue');

var Olapic = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/Olapic.vue');

var StoreAvailability = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/StoreAvailability.vue');

var ProductSeo = () => import(
/* webpackChunkName: "product-seo-tracking" */
'~/components/functional/Seo/ProductSeo.vue');

var OpenGraph = () => import(
/* webpackChunkName: "product-seo-tracking" */
'~/components/functional/OpenGraph/ProductOpenGraph.vue');

var JsonLd = () => import(
/* webpackChunkName: "product-seo-tracking" */
'~/components/functional/JsonLD/ProductJsonld.vue');

var ProductSheetTcVars = () => import(
/* webpackChunkName: "product-seo-tracking" */
'~/components/functional/TcVars/ProductSheetTcVars.vue');

var PendingTag = () => import('~/components/functional/TcVars/PendingTag.vue');

export default {
  validate(_ref) {
    var {
      params: {
        alias
      }
    } = _ref;
    return alias && extractProductReference(alias);
  },

  components: {
    ProductLoading,
    CommercialRibbon,
    SquareImage,
    MdmBreadcrumb,
    ZoomableImage,
    YoutubeModal,
    ProductFlags,
    ThePriceSection,
    TheVariantsSection,
    ZoomModal,
    ProductGlide,
    Heart,
    ThumbnailList,
    ProductStock,
    TheEmailForm,
    TheCartSection,
    StoreAvailability,
    Reinsurance,
    ProductInformation,
    CrossEarlyBirds,
    ShopTheLook,
    Olapic,
    ProductSeo,
    JsonLd,
    OpenGraph,
    ProductSheetTcVars,
    PendingTag,
    MdmIcon
  },

  fetch(_ref2) {
    return _asyncToGenerator(function* () {
      var {
        params: {
          alias
        },
        query,
        store,
        error
      } = _ref2;
      registerStoreModule(store, 'product/', product);

      if (process.server) {
        try {
          yield store.dispatch('product/fetchProduct', {
            alias,
            query
          });
        } catch (err) {
          error({
            statusCode: 404,
            message: 'Not Found'
          });
        }
      }
    })();
  },

  asyncData() {
    return {
      serverFetch: process.server
    };
  },

  data() {
    return {
      olapic: null,
      asyncStylesheetMedia: 'none',
      stockAlert: false,
      showModal: false,
      showYoutubeModal: false,
      imageIndex: 0,
      mediumLower: true,
      productGlideEnabled: true,
      trackingWibilongActive: false,
      trackingWibilongDisplay: null,
      carouselNavigationIndex: ''
    };
  },

  httpHeaders: () => ({
    'Cache-Control': 'max-age=0, s-maxage=600, public'
  }),
  computed: _objectSpread(_objectSpread({}, mapGetters({
    baseURL: 'request/baseURL',
    locale: 'i18n/locale',
    productInspiration: 'product/productInspiration',
    productCross: 'product/productCross',
    productComplementary: 'product/productComplementary',
    product: 'product/product',
    currentImage: 'product/currentImage',
    variants: 'product/variants'
  })), {}, {
    urlBuilder() {
      return urlBuilder;
    },

    medias() {
      var {
        images
      } = this.product;
      var {
        video
      } = this.product.additionalInformation;
      if ((video || video.length > 0) && this.isDesktop()) return images.concat(video);
      return images;
    },

    productName() {
      var lot = '';

      if (this.product.quantity && this.product.quantity > 1) {
        lot = " - ".concat(this.$tc('lot', this.product.quantity, {
          x: this.product.quantity
        }));
      }

      return "".concat(this.product.name).concat(lot);
    },

    isWibilongAuthorized() {
      return this.locale.market === 'FR';
    },

    showProductCross() {
      return this.productCross && this.productCross.products.length;
    },

    showProductComplementary() {
      return this.productComplementary && this.productComplementary.products.length;
    },

    trackingWibilongClick() {
      return {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Click_conseil_utilisateur',
          event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5, "/").concat(this.product.reference)
        }
      };
    },

    customizeProductUrl() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/e/so-me-lampadaire?primary=").concat(this.product.reference, "&secondary=").concat(this.product.reference);
    },

    countryWithStores() {
      // const excludedMarkets = ['UK', 'PT', 'AT', 'NL'];
      // return excludedMarkets.filter((market) => market === this.locale.market).length === 0;
      var openStores = ['fr-FR', 'fr-BE', 'nl-BE', 'fr-CH', 'de-CH', 'it-CH', 'de-DE', 'fr-LU', 'it-IT', 'es-ES', 'de-AT'];
      return openStores.includes(this.locale.iso);
    },

    sequraPredicate() {
      if (this.locale.market === 'ES' && !this.product.isPro && this.actualPrice >= 50) return true;
      return false;
    },

    actualPrice() {
      return this.product.price.sales.amount ? this.product.price.sales.amount : this.product.price.base.amount;
    },

    formattedBreadcrumb() {
      var result = [];

      if (this.product.additionalInformation.breadcrumbDisplay) {
        result = this.product.additionalInformation.breadcrumbDisplay.map(entry => ({
          text: entry.label,
          to: entry.hash ? "".concat(this.buildCategoryUrl(this.locale, 'slug', entry.hash)) : '',
          href: entry.url ? "".concat(entry.url) : "".concat(this.baseURL).concat(this.buildCategoryUrl(this.locale, 'slug', entry.hash))
        }));
      }

      return result;
    },

    hasAlertStockForm() {
      return this.product.stock.status === 'SOON' && this.product.additionalInformation.pricesType === 'T' || this.stockAlert;
    },

    hasVariants() {
      return this.variants.length;
    },

    isBuyable() {
      return this.product.additionalInformation.buyable;
    },

    currentPath() {
      return "".concat(this.baseURL).concat(this.buildProductUrl(this.locale, this.product.slug, this.product.reference));
    },

    hasSlider() {
      return this.isTablet() && this.product.images.length > 11 || this.isDesktop() && this.product.images.length > 5;
    },

    speedcurveConfig() {
      var luxConfig = {
        innerHTML: 'LUX = window.LUX || {}; LUX.label = "productsheet";'
      };
      return luxConfig;
    },

    openGraphMetaDescription() {
      return this.product.additionalInformation.metaDescription || '';
    },

    hasVideo() {
      return this.product.additionalInformation.video.length > 0;
    },

    isMarketplaceOpen() {
      return USE_MARKETPLACE(this);
    }

  }),

  created() {
    registerStoreModule(this.$store, 'product/', product, true);

    if (process.client && !this.serverFetch) {
      var {
        params: {
          alias
        },
        query
      } = this.$route;
      var args = {
        alias,
        query,
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : ''
      };
      this.resetProduct();

      try {
        this.fetchProduct(args).then(() => {
          this.wibilong();
        });
      } catch (error) {
        this.$logger.error(error);
      }
    }
  },

  mounted() {
    // don't fetch cross and complementary product for MKP
    if (this.serverFetch && !this.product.marketplace) {
      this.fetchCross();
    } else {
      this.createEbRecord();
    }

    this.bindScrollListener();
    this.stockAlert = this.$cookies.get('alertStock');
    this.mediumLower = !this.isDesktop();
    this.redirectToAnchor();
  },

  destroyed() {
    this.unbindScrollListener();
  },

  methods: _objectSpread(_objectSpread(_objectSpread({
    redirectToAnchor() {
      if (this.$router.currentRoute.hash) {
        var getAnchorUrl = this.$router.currentRoute.hash;
        var anchorId = document.querySelector(getAnchorUrl);
        var getHeaderHeight = document.getElementsByTagName('header')[0].offsetHeight;
        this.$nextTick(() => {
          window.scrollTo({
            top: anchorId.getBoundingClientRect().top - getHeaderHeight,
            behavior: 'smooth'
          });
        });
      }
    }

  }, mapMutations({
    resetProduct: 'product/RESET_PRODUCT'
  })), mapActions({
    fetchProduct: 'product/fetchProduct',
    fetchProductCarousels: 'product/fetchProductCarousels'
  })), {}, {
    fetchCross() {
      var crossPredicate = this.productCross && this.productCross.products && this.productCross.products.length;
      var args = {
        alias: this.$route.params.alias,
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : '',
        exclude: crossPredicate ? this.productCross.products.map(item => item.reference) : []
      };
      this.fetchProductCarousels(args).then(() => {
        this.createEbRecord();
        this.wibilong();
      });
    },

    createEbRecord() {
      var ebRecoIds = [];

      if (this.productCross) {
        var crossId = this.productCross.earlybirdsWidgets ? this.productCross.earlybirdsWidgets.id : null;
        ebRecoIds.push(crossId);
      }

      if (this.productComplementary) {
        var complementaryId = this.productComplementary.earlybirdsWidgets ? this.productComplementary.earlybirdsWidgets.id : null;
        ebRecoIds.push(complementaryId);
      }

      window.ebRecoIds = ebRecoIds;
    },

    emitGenericTrackingWibilong() {
      this.$root.$emit('generic-tracking', {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_questions reponses_wibilong',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    },

    bindScrollListener() {
      this.$root.$on('scroll-to-bottom', this.handleBottomBlocks);
      window.addEventListener('scroll', this.handleBottomBlocks, {
        passive: true
      });
    },

    unbindScrollListener() {
      this.$root.$off('scroll-to-bottom');
      window.removeEventListener('scroll', this.handleBottomBlocks);
    },

    handleBottomBlocks() {
      this.olapic = 'olapic';
      this.unbindScrollListener();
    },

    wibilong() {
      if (this.isWibilongAuthorized) {
        this.asyncScript(WIBILONG_JS_URL).then(() => {
          this.trackingWibilongActive = true;
          this.trackingWibilongDisplay = {
            data: {
              event_category: 'FicheProduit',
              event_action: 'Display_conseil_utilisateur',
              event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5, "/").concat(this.product.reference),
              event_is_non_interactive: 1
            }
          };
        }).catch(err => {
          this.$logger.error("WIBILONG_JS_URL FAILED ".concat(err));
        });
      }
    },

    handleWibilong() {
      this.asyncStylesheetMedia = 'all';
    },

    handleClickDescription(event) {
      try {
        var {
          productInformation
        } = this.$refs;
        window.scrollTo({
          top: productInformation.$el.offsetTop - 100,
          behavior: 'smooth'
        });
      } catch (error) {
        this.$logger.error(error);
      }

      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_description',
          event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    },

    openModal() {
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },

    carouselNavigation() {
      this.$root.$on('carousel-navigation', e => {
        this.carouselNavigationIndex = e.carouselNavigation;
      });
      return this.carouselNavigationIndex ? this.carouselNavigationIndex : "1/".concat(this.medias.length);
    },

    openYoutubeModal() {
      this.showYoutubeModal = true;
    },

    closeYoutubeModal() {
      this.showYoutubeModal = false;
    }

  }),

  head() {
    return {
      link: [{
        rel: 'stylesheet',
        src: WIBILONG_CSS_URL,
        media: this.asyncStylesheetMedia,
        onload: this.handleWibilong
      }, {
        rel: 'prerender',
        url: "".concat(this.baseURL, "/").concat(this.locale.market, "/").concat(this.locale.language, "/panier.html")
      }, {
        rel: 'prerender',
        url: "".concat(this.baseURL, "/").concat(this.locale.market, "/").concat(this.locale.language, "/cart")
      }],
      script: [this.speedcurveConfig]
    };
  }

};